import React, {Component} from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import Transition from 'react-transition-group/Transition';
import './App.css'
import Main from './Main'
import Header from './Header'
import FactsGrid from './FactsGrid'

const duration = 400;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
  flexGrow: 1,
  display: 'flex'
}

const transitionStyles = {
  entering: { opacity: 0 },
  entered:  { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0 }
};

const Fade = (props) => (
  <Transition in={props.in} timeout={props.timeout || 1000} appear={true} exit={true}>
    {(state) => (
      <div style={{
        ...defaultStyle,
        ...transitionStyles[state]
      }}>
        {props.children}
      </div>
    )}
  </Transition>
);


class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <Route path="/" component={Header} />
          <Route path="/" exact render={({match}) => (
            <Fade in={match.isExact} timeout={300}>
              <Main/>
            </Fade>
          )}/>
          <Route path="/FlashCards/math/Add/10" render={({match}) => (
            <Fade in={match.isExact} >
              <FactsGrid subject="add" size={10}/>
            </Fade>)
          }/>
          <Route path="/FlashCards/math/Mult/10" render={({match}) => (
            <Fade in={match.isExact} >
              <FactsGrid subject="mult" size={10}/>
            </Fade>)
          }/>
          <Route path="/FlashCards/math/Mult/12" render={({match}) => (
            <Fade in={match.isExact} >
              <FactsGrid subject="mult" size={12}/>
            </Fade>)
          }/>
        </div>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js